import './PlatformSwitch.less'

import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'
import Card from './Card'
import { Layout } from '../Layout/Layout'
import i18n from 'i18next'

import secondaryLogo2324 from '../../assets/images/secondary_23-24.png'
import primaryLogo from '../../assets/images/primary.png'
import higherLogo from '../../assets/images/higher.jpg'
import { Link } from 'react-router-dom'
import config from '../../config'

export const getLocale = () => {
  const selectedLanguage = i18n.language.toUpperCase()
  switch (selectedLanguage) {
    case 'NL':
      return 'nl-be'
    case 'FR':
      return 'fr-be'
    default:
      return ''
  }
}

class PlatformSwitch extends Component {
  state = {
    localChoice: localStorage.getItem('show-platform-switch'),
    callbackUrl: new URLSearchParams(window.location.search).get('callbackUrl'),
  }

  onChoiceChange = e => {
    console.log(e.target.value)


    if (this.state.localChoice) {
      localStorage.removeItem('show-platform-switch')
      this.setState({ localChoice: undefined })
      return
    }

    localStorage.setItem('show-platform-switch', e.target.value)
    this.setState({ localChoice: e.target.value })
  }

  onCardClick = platform => {
    localStorage.setItem('selected-platform', platform)

    if (this.state.callbackUrl) {
      window.location.href = window.location.origin + this.state.callbackUrl + '&SelectedPlatform=' + platform
    }
  }

  componentDidMount = () => {
    const localPlatform = localStorage.getItem('selected-platform')
    const localShowPlatformSwitch = localStorage.getItem('show-platform-switch')
    const isResetQueryParam = new URLSearchParams(window.location.search).get('reset-platform')

    if (isResetQueryParam === 'true') {
      localStorage.removeItem('selected-platform')
      localStorage.removeItem('show-platform-switch')

      this.setState({ localChoice: null })
    } else {
      if (localPlatform && localShowPlatformSwitch === 'no') {
        if (localPlatform === 'primary') {
          this.props.history.push('/login')
        } else if (localPlatform === 'secondary') {
          const locale = getLocale()
          if (this.state.callbackUrl) {
            window.location.href =
              window.location.origin + this.state.callbackUrl + '&SelectedPlatform=' + localPlatform
          } else {
            window.location.href = `https://apps.plantyn.com/se${locale ? '?lng=' + locale : ''}`
          }
        } else if (localPlatform === 'higher') {
          const locale = getLocale()
          if (this.state.callbackUrl) {
            window.location.href =
              window.location.origin + this.state.callbackUrl + '&SelectedPlatform=' + localPlatform
          } else {
            window.location.href = `https://apps.plantyn.com/se${locale ? '?lng=' + locale : ''}`
          }
        }
      }
    }

    if (config.user) {
      this.props.history.push('/login')
    }
  }

  render() {
    const t = this.props.t

    const locale = getLocale()

    return (
      <Layout noContentWrapper>
        <div className="platform-switch-page-container">
          <div className="platform-switch-container">
            <div className="platform-switch-title">
              <h1>{t('title')}</h1>
            </div>
            <div className="choice" id="choice-lg">
              <label htmlFor="save-answer-no">
                <div className="labels-container">
                  <div className="labels-inner-container">
                    <div className="labels-input-wrapper">
                      <input
                        type="checkbox"
                        id="save-answer-no"
                        name="save-answer"
                        value="no"
                        onChange={this.onChoiceChange}
                        checked={this.state.localChoice === 'no'}
                      />
                      <svg
                        className="checkmark"
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.7066 0.293762C14.0973 0.684387 14.0973 1.31876 13.7066 1.70939L5.70664 9.70939C5.31602 10.1 4.68164 10.1 4.29102 9.70939L0.291016 5.70939C-0.0996094 5.31876 -0.0996094 4.68439 0.291016 4.29376C0.681641 3.90314 1.31602 3.90314 1.70664 4.29376L5.00039 7.58439L12.2941 0.293762C12.6848 -0.0968628 13.3191 -0.0968628 13.7098 0.293762H13.7066Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <span className="first-word">{t('saveAnswerNo') + ' '} </span>
                    <span className="label-title">{t('saveAnswerNoTitle')}</span>
                  </div>
                </div>
              </label>
            </div>

            <div className="cards-container">
              {!this.state.callbackUrl ? (
                <React.Fragment>
                  <Link to="/login" onClick={() => this.onCardClick('primary')}>
                    <Card title={t('primaryCardTitle')} img={primaryLogo} />
                  </Link>
                  <a
                    onClick={() => this.onCardClick('secondary')}
                    href={`https://apps.plantyn.com/se${locale ? '?lng=' + locale : ''}`}
                  >
                    <Card
                      title={t('secondaryCardTitle')}
                      img={secondaryLogo2324}
                      maintenanceText={t('maintenanceText')}
                    />
                  </a>
                  <a onClick={() => this.onCardClick('higher')} href={`https://apps.plantyn.com/se${locale ? '?lng=' + locale : ''}`}>
                    <Card title={t('higherCardTitle')} img={higherLogo} maintenanceText={t('maintenanceText')} />
                  </a>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div onClick={() => this.onCardClick('primary')}>
                    <Card title={t('primaryCardTitle')} img={primaryLogo} />
                  </div>
                  <div onClick={() => this.onCardClick('secondary')}>
                    <Card
                      title={t('secondaryCardTitle')}
                      img={secondaryLogo2324}
                      maintenanceText={t('maintenanceText')}
                    />
                  </div>
                  <div onClick={() => this.onCardClick('higher')}>
                    <Card title={t('higherCardTitle')} img={higherLogo} maintenanceText={t('maintenanceText')} />
                  </div>
                </React.Fragment>
              )}
              <div className="choice" id="choice-sm">
                <label htmlFor="save-answer-no">
                  <div className="labels-container">
                    <div className="labels-inner-container">
                      <div className="labels-input-wrapper">
                        <input
                          type="checkbox"
                          id="save-answer-no"
                          name="save-answer"
                          value="no"
                          onChange={this.onChoiceChange}
                          checked={this.state.localChoice === 'no'}
                        />
                        <svg
                          className="checkmark"
                          width="14"
                          height="10"
                          viewBox="0 0 14 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.7066 0.293762C14.0973 0.684387 14.0973 1.31876 13.7066 1.70939L5.70664 9.70939C5.31602 10.1 4.68164 10.1 4.29102 9.70939L0.291016 5.70939C-0.0996094 5.31876 -0.0996094 4.68439 0.291016 4.29376C0.681641 3.90314 1.31602 3.90314 1.70664 4.29376L5.00039 7.58439L12.2941 0.293762C12.6848 -0.0968628 13.3191 -0.0968628 13.7098 0.293762H13.7066Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className='labels-text-wrapper'>
                        <span className="first-word">{t('saveAnswerNo') + ' '} </span>
                        <span className="label-title">{t('saveAnswerNoTitle')}</span>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

const translatePlatformSwitch = translate('platformSwitch')(withRouter(PlatformSwitch))

export { translatePlatformSwitch as PlatformSwitch }



// WEBPACK FOOTER //
// ./src/components/PlatformSwitch/PlatformSwitch.js